export const NotificationApiOrderBlacklist = {
    'domain.id': 'domain_id',
    'domain.name': 'domain_name',
    'notification.audiences.targeted': 'audiences',
    'notification.audiences.excluded': 'audiences',
}
